(function () {
  'use strict';
  var data = window.TTGCatalog || {games: [], grades: []};
  var tags = {singles:'SINGLE',sealed:'SEALED',order:'Ordinabile'};
  function current() { return new URLSearchParams(location.search); }
  function mode(p) {
    var q=p.get('q')||'';
    return /\btag:SINGLE\b/i.test(q)?'singles':/\btag:SEALED\b/i.test(q)?'sealed':/\btag:(?:"?Ordinabile"?)(?:\s|$)/i.test(q)?'order':'all';
  }
  function text(p) {
    if(p.has('ttg_q')) return p.get('ttg_q');
    return (p.get('q')||'').replace(/\s+(?:AND\s+)?tag:(SINGLE|SEALED|Ordinabile)\b/gi,'').replace(/^tag:(SINGLE|SEALED|Ordinabile)\b\s*/i,'').replace(/^\*$/,'').trim();
  }
  function quote(s) { return '"'+s.replace(/\\/g,'\\\\').replace(/"/g,'\\"')+'"'; }
  function normalize(q) { return q.trim().replace(/\s+/g,' '); }
  function build(q,m,p) {
    p=new URLSearchParams(p||current());p.delete('options');q=normalize(q);
    var game=data.games.find(function(g){return g.id===p.get('ttg_game');});
    var set=(p.get('ttg_set')||'').trim(), clauses=[];
    // Shopify supplies the surrounding page and live product cards. The complete
    // public catalogue supplies title matching: no prefix-only or word-expansion
    // heuristics may omit a product that contains the customer's text.
    if(tags[m]) clauses.push('tag:'+tags[m]);
    if(game) clauses.push('('+game.tags.map(function(t){return 'tag:'+quote(t);}).join(' OR ')+')');
    else p.delete('ttg_game');
    if(p.get('ttg_order_category')) clauses.push('tag:'+quote(p.get('ttg_order_category')));
    if(set) p.set('filter.p.tag',set);
    else {p.delete('ttg_set'); if(!p.get('ttg_keep_tag'))p.delete('filter.p.tag');}
    p.set('q',clauses.filter(Boolean).join(' AND ')||'*');p.set('ttg_q',q==='*'?'':q);
    p.set('type','product');p.set('options[prefix]','last');
    p.delete('page');p.delete('section_id');p.delete('view');
    p.delete('ttg_index');p.delete('ttg_match');
    if(q&&q!=='*')p.set('ttg_index','1');
    return p;
  }
  function fold(s){return String(s||'').normalize('NFKD').replace(/\p{M}/gu,'').toLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();}
  function score(product,q){
    var title=product.title||'', primary=product.single?title.split(' - ')[0]:title;
    var needle=fold(q),hay=fold(primary),all=fold(title),tokens=needle.split(' ').filter(Boolean);
    if(!tokens.length)return 1;
    var game=data.games.find(function(g){return fold(g.label)===needle||fold(g.id)===needle;});
    if(game && (product.tags||[]).some(function(t){return game.tags.some(function(gt){return fold(gt)===fold(t);});}))return 210;
    var direct=tokens.every(function(t){return all.includes(t);});
    var compact=needle.replace(/ /g,'');
    if(/\d/.test(compact)&&all.replace(/ /g,'').includes(compact))direct=true;
    if(!direct)return 0;
    var name=fold(primary.replace(/\([^)]*\)/g,'')),whole=tokens.every(function(t){return hay.split(' ').includes(t);}),primaryMatch=tokens.every(function(t){return hay.includes(t);});
    return name===needle?300:(whole?200:primaryMatch?100:50)-Math.min(25,Math.max(0,name.split(' ').length-tokens.length))+(name.startsWith(needle)?2:0);
  }
  function rank(products,q){return products.map(function(p,i){return {p:p,i:i,s:score(p,q)};}).sort(function(a,b){return b.s-a.s||a.i-b.i;});}
  function related(product,q){var text=fold((product.title||'')+' '+(product.description||''));return fold(q).split(' ').filter(Boolean).every(function(t){return text.includes(t);});}
  window.TTGSearch={current:current,mode:mode,text:text,build:build,data:data,normalize:normalize,score:score,rank:rank,related:related};
})();
